import styled, { css } from "styled-components";
import { DataFlowItemProps } from ".";
import IconActive from "../../../styles/assets/svg/icon_data_active.svg";
import IconStopped from "../../../styles/assets/svg/icon_data_stopped.svg";

export const DataFlowItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 5px;
`;

export const FlowTileLabel = styled.div`
  display: flex;
  min-width: 60px;
  height: 30px;
  color: ${(props) => props.theme.colors.white100};
  font-size: 1.4rem;
  font-weight: 600;
  background: ${(props) => props.theme.colors.labelBox};
  border-radius: 6px;
  align-items: center;
  justify-content: center;
  padding: 10px;
  gap: 5px;
`;

export const FlowLed = styled.div<DataFlowItemProps>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${(props) =>
    props.status === "normal"
      ? props.theme.colors.greenStatus
      : props.status === "ready"
      ? props.theme.colors.yellowStatus
      : props.theme.colors.redStatus};
`;

export const FlowTile = styled.div<DataFlowItemProps>`
  position: relative;
  display: flex;
  width: 130px;
  height: 130px;
  background: ${(props) => props.theme.colors.white100};
  border-radius: 20px;
  align-items: center;
  justify-content: center;

  & > div {
    display: flex;
    width: 120px;
    height: 120px;
    border: 1px solid
      ${(props) =>
        props.unit === "ecs"
          ? props.theme.colors.redStatus
          : props.unit === "save"
          ? props.theme.colors.yellowStatus
          : props.unit === "send"
          ? props.theme.colors.greenStatus
          : props.theme.colors.blueStatus};
    border-radius: 16px;
    align-items: center;
    justify-content: center;

    div {
      display: flex;
      width: 100px;
      height: 100px;
      border-radius: 12px;
      background: ${(props) =>
        props.unit === "ecs"
          ? props.theme.colors.redStatus
          : props.unit === "save"
          ? props.theme.colors.yellowStatus
          : props.unit === "send"
          ? props.theme.colors.greenStatus
          : props.theme.colors.blueStatus};
      align-items: center;
      justify-content: center;
    }
  }

  &::before {
    position: absolute;
    content: "";
    background-size: contain;
    background-position: center;

    ${(props) =>
      props.active === true &&
      css`
        width: 80px;
        height: 22px;
        left: -79px;
        background-image: url(${IconActive});
        background-repeat: no-repeat;
      `};

    ${(props) =>
      props.active === false &&
      css`
        width: 78px;
        height: 22px;
        left: -79px;
        background-image: url(${IconStopped});
        background-repeat: no-repeat;
      `};
  }
`;

export const FlowTimeTxt = styled.div`
  height: 30px;
  font-size: 1.4rem;
  line-height: 30px;
  text-align: center;
`;
